import { render, staticRenderFns } from "./yi_header.vue?vue&type=template&id=792deb82&scoped=true&"
import script from "./yi_header.vue?vue&type=script&lang=js&"
export * from "./yi_header.vue?vue&type=script&lang=js&"
import style0 from "./yi_header.vue?vue&type=style&index=0&id=792deb82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792deb82",
  null
  
)

export default component.exports